import { createApp } from 'vue'
import App from './App.vue'
// import "bootstrap/dist/css/bootstrap.min.css"
// import "bootstrap"

const dataId = document.querySelector("#placementtestapp")?.getAttribute('data-id');

// createApp(App, {'id': parseInt(dataId) }).mount('#placementtestapp')

// Wait for course data to be ready before mounting Vue
console.log('Vue app loaded, waiting for course data...');

window.addEventListener('course-data-ready', function() {
    console.log('Course data ready, mounting Vue app');
    createApp(App).mount('#placementtestapp');
}, { once: true }); // Only listen once

// Fallback: Mount after 500ms if event doesn't fire
setTimeout(() => {
    const el = document.querySelector('#placementtestapp');
    if (el && !el.__vue_app__) {
        console.log('Fallback: Mounting Vue app after timeout');
        createApp(App, {'id': parseInt(dataId) }).mount('#placementtestapp')
    }
}, 500);
